<template>
  <div>
    <div class="table-responsive">
      <table class="table p-0 m-0 dataTable min-h-[150px] text-nowrap">
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Role Name
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Assigned Users
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Type
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Created
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div
                class="text-center"
                style="padding-top: 100px; padding-bottom: 50px"
              >
                <span
                  class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                  style="font-size: 8rem"
                ></span>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  Please wait while we loading the Role's Lists
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="role in roles" :key="role.id" v-else>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{ role.roleName }}
            </td>
            <td>
              <span
                class="flex items-center gap-[4px] max-w-max w-full"
                :class="[
                  'badge',
                  {
                    'badge-success': role.numberOfAssignedUsers > 0,
                    'badge-danger': role.numberOfAssignedUsers <= 0,
                  },
                ]"
              >
                <span
                  class="w-[10px] h-[10px] rounded-[1px]"
                  :style="{
                    backgroundColor:
                      role.numberOfAssignedUsers > 0 ? '#16a249' : '#EF5253',
                  }"
                ></span>
                <span class="text-[12px] font-normal leading-[16.94px]">{{
                  role.numberOfAssignedUsers > 0 ? "Assigned" : "Not Assigned"
                }}</span>
              </span>
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{ role.numberOfAssignedUsers }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{
                role.roleType === "Office"
                  ? "Business"
                  : role.roleType === "SalesForce"
                  ? "Sales"
                  : role.roleType
              }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px]">
              {{ formatDate(role.created) }}
            </td>
            <td @click="toggleDropdown(role.id)">
              <div class="dropdown">
                <button
                  class="btn-no-border"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span
                    class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                  >
                    ...
                  </span>
                </button>
                <ul
                  class="dropdown-menu shadow-none"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li
                    @click="viewRoleUsers(role)"
                    v-if="
                      hasPermission('Role_User_View') ||
                        (hasPermission('Sales_Role_View') &&
                          role.numberOfAssignedUsers > 0)
                    "
                    class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer border-b border-[#e5e7eb] py-[10px] px-[16px]"
                  >
                    View Assigned Users
                  </li>

                  <li
                    @click="viewEditRole(role, role.roleType)"
                    v-if="
                      hasPermission('Role_Update') ||
                        hasPermission('Sales_Role_Update')
                    "
                    :class="[
                      'text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]',
                      hasPermission('Role_Delete') &&
                      role.roleName.toLowerCase() != 'administrator' &&
                      role.roleName.toLowerCase() != 'support specialist' &&
                      role.roleName.toLowerCase() != 'view only' &&
                      role.roleName.toLowerCase() != 'sales'
                        ? 'border-b border-[#e5e7eb]'
                        : '',
                    ]"
                  >
                    Edit Role
                  </li>

                  <li
                    v-if="
                      hasPermission('Role_Delete') ||
                        (hasPermission('Sales_Role_Delete') &&
                          role.roleName.toLowerCase() != 'administrator' &&
                          role.roleName.toLowerCase() != 'support specialist' &&
                          role.roleName.toLowerCase() != 'view only' &&
                          role.roleName.toLowerCase() != 'sales')
                    "
                    class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]"
                    @click="deleteRole(role)"
                  >
                    Delete Role
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="!roles.length && !loading" class="min-h-screen">
            <td colspan="12">
              <div class="text-center" style="padding-top: 50px">
                <span
                  style="font-size: 4.615rem"
                  class="fa-solid fa-suitcase text-[#2463EB]"
                ></span>
              </div>
              <h3
                class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                style="padding-bottom: 100px"
              >
                You don't have any roles
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :limit="pageSize"
        :count="pageCount"
        :page="pageNumber"
        :itemsCount="count"
        @changePage="gotoPage"
        @changeLimit="changeLimit"
      />
    </div>

    <!-- add business roles -->
    <div class="modal fade" id="mod-add-sales" role="dialog">
      <div
        class="modal-dialog p-0 m-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content  h-full md:min-h-screen rounded-none bg-[#f8f8f8] p-[40px]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px capitalize text-[#353535] pb-[16px]"
            >
              Create New Business Role
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div>
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Role Name</label
              >
              <div>
                <input
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  v-model="createRole.name"
                  class="bg-[[#fcfcfd]] border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                  placeholder="Enter role name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mt-[16px]">
              <div>
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Permissions</label
                >
                <div
                  class="bg-white w-full"
                  style="height: 320px; overflow-y: scroll"
                >
                  <ol
                    v-if="permissionsListCreate.length > 0"
                    class="flex flex-col gap-[5px] w-full"
                  >
                    <li v-for="item in permissionsListCreate" :key="item.id">
                      <div
                        class="flex items-center justify-between gap-[5px] py-[14px] px-[10px] border-b border-[#eee] cursor-pointer"
                        @click="item.state.opened = !item.state.opened"
                      >
                        <input
                          type="checkbox"
                          :disabled="item.state.disabled"
                          :name="item.text"
                          :checked="item.state.selected"
                          class="custom-checkbox"
                          @click.stop="
                            item.state.selected = !item.state.selected
                          "
                          @change="
                            onPermissionChange(item, item.state.selected)
                          "
                        />
                        <label
                          :for="item.text"
                          class="text-[#353535] font-medium text-[16px] m-0 w-full"
                          >{{ item.text }}</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300"
                          :class="item.state.opened ? 'rotate-180' : 'rotate-0'"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                      <ol v-if="item.children.length != 0 && item.state.opened">
                        <li
                          v-for="children in item.children"
                          :data-id="children.id"
                          class="border-b border-[#eee]w-full py-[11px]"
                          :key="children.id"
                        >
                          <div class="px-[28px] flex items-center gap-[8px]">
                            <input
                              type="checkbox"
                              :name="children.text"
                              :checked="children.state.selected"
                              :disabled="children.state.disabled"
                              class="custom-checkbox"
                              @click="
                                children.state.selected = !children.state
                                  .selected
                              "
                            />
                            <label
                              :for="children.text"
                              class="text-[#353535] font-normal text-[14px] m-0 w-full"
                              >{{ children.text }}</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              type="button"
              data-dismiss="modal"
              :disabled="isBusyModal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="create"
            >
              {{ isBusyModal ? "Loading..." : "Add Role" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <ViewAsignedRole
      :roleUsers="roleUsers"
      :roleInfo="roleInfo"
      v-if="isModalVisible"
      :close="closeModal"
    />
    <SalesRole
      :salesEdit="salesEdit"
      :editRoles="editRole"
      @salesRoleCompleted="handleCreateUserSalesComplete"
      @EditComplete="handleSalesEditComplete"
    />
    <BusinessRole
      :editRoles="editRole"
      :businessEdit="businessEdit"
      @roleComplete="handleBusinessComplete"
    />
    <DeleteCaution
      :roleId="roleId"
      :role="role"
      @deletion-success="handleDeletionSuccess"
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "../Select2";
import SystemPermissions from "@/permissions";
import Pagination from "../Pagination.vue";
import ViewAsignedRole from "../User/ViewAsignedRole.vue";
import BusinessRole from "../User/BusinessRole.vue";
import SalesRole from "../User/SalesRole.vue";
import DeleteCaution from "./DeleteCautionRole.vue";
import { bus } from "../../main";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsRoles",
  components: {
    Select2,
    Pagination,
    ViewAsignedRole,
    BusinessRole,
    SalesRole,
    DeleteCaution,
  },
  created() {
    this.getRoles();
    this.getPermissions();
  },
  watch: {},
  data() {
    return {
      filter: {
        status: "0",
        qry: "",
      },
      roleId: null,
      isBusy: false,
      isBusyModal: false,
      createRole: {
        name: null,
        permissions: [],
      },
      updateRole: {
        name: "",
        id: null,
        permissions: [],
      },
      editRole: {
        name: null,
        id: null,
        permissions: null,
      },
      v1: {
        name: false,
      },
      v2: {
        name: false,
      },
      roles: [],
      isModalVisible: false,
      showDropdown: null,
      permissions: [],
      count: 0,
      page: 1,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      businessEdit: false,
      salesEdit: false,
      loading: true,
      role: {},
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    permissionsListCreate() {
      return this.createRole.permissions.map((b) => {
        return b;
      });
    },
    permissionsListUpdate() {
      return this.updateRole.permissions.map((b) => {
        return b;
      });
    },
  },
  methods: {
    checkPermission(permission) {
      return (
        (this.userType === "Office" &&
          this.permissions[`Role_${permission}`]) ||
        (this.userType === "SalesForce" &&
          this.permissions[`Sales_Role_${permission}`])
      );
    },
    handleBusinessComplete() {
      $("#mod-edit-role").modal("hide");
      this.getRoles();
    },
    handleSalesEditComplete() {
      $("#mod-edit-sales").modal("hide");
      this.getRoles();
    },
    handleCreateUserSalesComplete() {
      $("#mod-add-role").modal("hide");
      this.getRoles();
    },
    handleDeletionSuccess() {
      $("#delete-role-modal").modal("hide");
      this.getRoles();
      this.roleId = null;
    },
    toggleDropdown(userId) {
      this.showDropdown = this.showDropdown === userId ? null : userId;
    },
    closeModal() {
      this.isModalVisible = !this.isModalVisible;
      this.getRoles();
    },
    onPermissionChange(item, state) {
      for (let child of item.children) {
        child.state.selected = state;
      }
    },
    reset() {
      this.filter = {
        status: "0",
        qry: "",
      };
    },
    cancel() {
      $("#mod-edit-role").modal("hide");
    },
    async viewRoleUsers(r) {
      var roleId = r.id;
      let roleType =
        r.roleType == "Office"
          ? "business"
          : r.roleType == "SalesForce"
          ? "sales"
          : "";
      let url =
        roleType == "business"
          ? "/Roles/getAssignedUserList"
          : roleType == "sales"
          ? "/SalesRoles/getAssignedUserList"
          : "";
      this.isBusy = true;
      await this.$http
        .get(`${url}?page=` + 0 + "&pageSize=" + 10 + ("&roleId=" + roleId))
        .then(function(res) {
          this.roleUsers = res.body.data;
          this.isBusy = false;
        })
        .catch(function(err) {});
      this.roleInfo = { id: r.id, name: r.roleName };
      this.isModalVisible = true;
      this.isBusy = false;
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },
    viewAdd() {
      this.createRole = {
        name: null,
        permissions: JSON.parse(JSON.stringify(this.permissions)),
      };
      this.v1 = {
        name: false,
      };
      this.salesEdit = false;
      this.businessEdit = false;
      $("#mod-add-sales").modal("show");
    },
    async viewEditRole(c, type) {
      var editValues = {
        name: c.roleName,
        id: c.id,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };
      this.editRole = editValues;
      this.updateRole = {
        id: c.id,
        name: c.roleName,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
        ...c,
      };

      if (type == "Office") {
        $("#mod-edit-role").modal("show");
        this.businessEdit = true;
      } else {
        const res = await this.$http.get(
          `/SalesRoles/getRoleList?parentId=${this.user.parentId}&pageSize=10&page=0&query=${c.roleName}`
        );
        const data = await res.json();
        let selectedRoleList = data.data;

        let dataValue = selectedRoleList.find((v) => v.id == c.id) || {};
        this.editRole = dataValue;
        $("#mod-edit-sales").modal("show");
        this.salesEdit = true;
      }
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    deleteRole(role) {
      this.roleId = role.id;
      this.role = role;

      $("#delete-role-modal").modal("show");
    },
    async create() {
      try {
        this.isBusyModal = true;
        this.isBusy = true;

        const data = {
          name: this.createRole.name,
          parentId: this.user.parentId,
          roleType: this.user.type,
          permissions: this.createRole.permissions,
        };

        if (this.validateCreate()) {
          const response = await this.$http.post("/Roles/create", data);

          if (response.ok) {
            this.$toast.success("Role created successfully.", {
              icon: true,
              rtl: false,
            });
            bus.$emit("getroles");
            $("#mod-add-sales").modal("hide");
            await this.getRoles();
          }
        }
      } catch (error) {
        console.error("Error creating role:", error);
        this.$toast.error("Failed to create role. Please try again.", {
          icon: true,
          rtl: false,
        });
      } finally {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },
    validateCreate() {
      this.v1 = {
        name: false,
      };
      var isValid = true;

      if (!this.createRole.name) {
        this.v1.name = true;
        isValid = false;
      }

      return isValid;
    },
    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      const data = {
        name: this.updateRole.name,
        permissions: this.updateRole.permissions,
        roleId: this.updateRole.id,
        parentId: this.user.parentId,
      };

      if (this.validateUpdate()) {
        $("mod-edit-role").modal("hide");

        await this.$http
          .put("/Roles/update/" + data.roleId, data)
          .then(function(res) {
            this.isBusyModal = false;
            $("#mod-edit-role").modal("hide");
          })
          .catch(function() {});
        this.getRoles();
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateUpdate() {
      this.v2 = {
        name: false,
      };
      var isValid = true;

      if (!this.updateRole.name) {
        this.v2.name = true;
        isValid = false;
      }

      return isValid;
    },
    async getRoles() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Roles/getAllEnterpriseRoles?pageNumber=" +
            this.pageNumber +
            "&pageSize=" +
            this.pageSize +
            "&roleType=" +
            this.user.type +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "")
        )
        .then(function(res) {
          this.roles = res.body;
          this.page = res.body.pageNumber;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function(err) {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    async getPermissions() {
      this.isBusy = true;

      await this.$http
        .get("/Roles/getPermissionList?roleType=" + this.user.type)
        .then(function(res) {
          this.permissions = res.body;
          this.createRole.name = "";
          this.createRole.permissions = this.permissions;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
        })
        .catch(function(err) {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.pageNumber -= 1;
      this.getRoles();
    },

    next() {
      this.pageNumber += 1;
      this.getRoles();
    },

    gotoPage(page) {
      this.pageNumber = page - 1;
      this.getRoles();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getRoles();
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
